import axiosClient from './axiosClient';

const userController = {
  getCustomerUsers(token, customerId, pageSize = 1000, page = 0) {
    const url = `/api/customer/${customerId}/users?pageSize=${pageSize}&page=${page}`;
    return axiosClient.get(url, {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    });
  },
  saveUser(token, user) {
    const url = '/api/user?sendActivationMail=false';
    const payload = user;
    return axiosClient.post(url, payload, {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    });
  },
  getActivationLink(token, userId) {
    const url = `/api/user/${userId}/activationLink`;
    return axiosClient.get(url, {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    });
  },
  activateUser(token, activateToken, password) {
    const url = '/api/noauth/activate?sendActivationMail=false';
    const payload = {
      activateToken: activateToken,
      password: password,
    };
    return axiosClient.post(url, payload, {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    });
  },
  deleteUser(token, userId) {
    const url = `/api/user/${userId}`;
    return axiosClient.delete(url, {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    });
  },
};

export default userController;
